module.exports = __webpack_public_path__ + "img/ic_loop_off.4dc29839.svg";